<template>
	<k-dialog v-model="dialog_open" :max-width="show_help?600:400" persistent scrollable :fullscreen="$vuetify.breakpoint.xs" aria-labelledby="satchel-sign-in-title" initial-focus-selector="input" @keydown.esc="cancel_sign_in"><div class="k-login-wrapper-outer"><k-spacer/>
		<div class="k-login-wrapper">
			<div class="k-login-logo-wrapper k-login-logo-wrapper-ext k-banner-color">
				<div class="k-login__logo-img-wrapper"><img class="k-login__logo-img" :alt="site_config.agency_name + ' logo'" :src="agency_logo_img_src"></div>
				<div v-if="show_app_name_with_logo!='false'" class="k-login__logo-text k-app-title-color k-sans-serif-font k-login__logo-text-ext"><b id="satchel-sign-in-title">{{app_name}}</b></div>
			</div>

			<div v-if="use_msft_oidc_login" class="d-flex mt-4 pt-4 pb-2 center justify-center align-center" style="border-top:1px solid #aaa; height:64px;">
				<k-btn @click="msft_sign_in" color="blue" dark class="center">
					Sign in with Microsoft
					<div class="ml-2 larger-svg-container">
						<object type="image/svg+xml" data="https://s3-eu-west-1.amazonaws.com/cdn-testing.web.bas.ac.uk/scratch/bas-style-kit/ms-pictogram/ms-pictogram.svg" class="x-icon white-bg"></object>
					</div>
				</k-btn>
			</div>

			<div class="mx-auto" style="max-width:400px">
				<k-text-field
					@keyup="keyup"
					ref="email_field"
					class="mt-3"
					background-color="#eee"
					outlined
					prepend-inner-icon="fa fa-envelope"
					label="Email Address"
					v-bind="formFields.email"
					@input="formFields.email.input"
					@blur="formFields.email.blur"
				/>
			</div>
			<div class="mx-auto" style="max-width:400px">
				<k-text-field
					@keyup="keyup"
					class="mt-4"
					background-color="#eee"
					outlined
					password
					prepend-inner-icon="fa fa-key" :type="show_password ? 'text' : 'password'"
					:append-icon="show_password ? 'fas fa-eye' : 'fas fa-eye-slash'"
					:append-aria-label="show_password ? 'Hide password' : 'Show password'"
					:append-aria-pressed="show_password"
					@click:append="show_password = !show_password"
					label="Password"
					autocomplete="current-password"
					v-bind="formFields.password"
					@input="formFields.password.input"
					@blur="formFields.password.blur"
				/>
			</div>

			<!-- help options for rosetta exchange -->
			<div v-if="instance_code=='rosetta_exchange'" class="mt-3 mb-4">
				<div class="text-center">
					<k-btn small text color="primary" class="k-tight-btn k-nocaps-btn" style="font-weight:normal" @click="show_help=!show_help">Need Help? Click Here!</k-btn>
				</div>
				<div v-show="show_help" class="pt-3 pb-4 mt-3 mx-4 elevation-2" style="background-color:#eee; border-radius:8px; font-size:16px; line-height:22px;">
					<ul>
						<li>I <b>already have an account</b> for {{site_config.app_name}}, but <k-btn class="k-tight-btn k-nocaps-btn mx-1 my-1" small color="primary" dark @click="forgot_password">I Forgot my Password <k-icon small class="ml-2">fas fa-face-confused</k-icon></k-btn></li>
						<li class="mt-2">I used to sign in through 1EdTech to CASE<sup>®</sup> Network 2 and <k-btn class="k-tight-btn k-nocaps-btn mx-1 my-1" small color="primary" dark @click="forgot_password('from_cn2')">My Previous Password Isn’t Working<k-icon small class="ml-2">fas fa-face-frown-open</k-icon></k-btn></li>
						<li class="mt-2">Learn how to <k-btn class="k-tight-btnx mx-1 my-1" small color="primary" dark @click="register_for_rosetta_exchange"><k-icon small class="mr-2">fas fa-list-check</k-icon>Register</k-btn> for signed-in access to {{site_config.app_name}}</li>
					</ul>
				</div>
			</div>

			<!-- default help options -->
			<div v-else class="mt-2">
				<k-btn v-if="site_config.show_create_account_on_login=='yes'" text small color="primary" class="k-tight-btn k-nocaps-btn xma-0" style="font-weight:normal;" @click="show_create_account_dialog=true" data-cy="show_create_account">Create account</k-btn>
				<k-btn small text color="primary" class="k-tight-btn k-nocaps-btn" style="font-weight:normal" @click="forgot_password">Forgot your password?</k-btn>
			</div>

			<div class="d-flex mt-2">
				<k-btn @click="cancel_sign_in" color="secondary">Cancel</k-btn>
				<k-spacer/>
				<k-btn @click="formHandleSubmit" color="primary">Sign In</k-btn>
			</div>
		</div>
		<CreateAccount v-if="show_create_account_dialog" @dialog_cancel="show_create_account_dialog=false" />
		<k-spacer/></div></k-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CreateAccount from './CreateAccount'
import { useFormMixin } from '@cglt/ui-legacy'
import { z } from 'zod'

export default {
	components: { CreateAccount },
	mixins: [
		useFormMixin({
			schema: z.object({
				email: z.email('Please enter your email address.'),
				password: z.string().min(1, 'Please enter your password.')
			}),
			initialValues: {
				email: U.local_storage_get('sparklsalt_login_email', ''),
				password: ''
			},
			onSubmit: function (values) {
				this.sign_in(values)
			}
		})
	],
	props: {
		// req: { type: String, required: true },
		// nreq: { type: String, required: false, default() { return ''} },
	},
	data() { return {
		dialog_open: true,
		show_password: false,
		show_help: false,
		show_create_account_dialog: false,
	}},
	computed: {
		...mapState(['login_error', 'site_config', 'redirected_from_cn2']),
		...mapGetters(['instance_code']),
		agency_logo_img_src() {
			if (!this.$store.state.site_config.agency_logo) return ''
			return this.$store.state.site_config.agency_logo
		},
		app_name() { return this.$store.state.site_config.app_name },
		show_app_name_with_logo() { return this.$store.state.site_config.show_app_name_with_logo },
		use_msft_oidc_login() { return this.$store.state.use_msft_oidc_login },
	},
	watch: {
	},
	created() {
	},
	mounted() {
		this.$nextTick(()=>{
			$(this.$refs.email_field.$el).find('input').focus()
		})
	},
	methods: {
		keyup(event) {
			if (event.code == 'Enter' || event.keyCode == 13) this.formHandleSubmit()
		},

		forgot_password(flag) {
			let text = 'Enter your email address and click the button below to send a one-time sign-in link to your email account. <b>This link will be valid for one hour.</b> After using the link to sign in, you can reset your password.'

			if (flag == 'from_cn2') {
				text = `<div class="mb-3">If you previously signed in to CASE<sup>®</sup> Network 2 with a 1EdTech password, your email address will still work to sign in, but you will need to establish a ${this.site_config.app_name}-specific password to use.</div>${text}`
			}

			this.$prompt({
				title: 'Forgot Password',
				text,
				initialValue: this.formFields.email.value,
				acceptText: 'Send One-Time Sign-In Link',
				dialogMaxWidth: 540,
				focusBtn: true,		// focus on the accept btn when dialog is rendered
				schema: z.email('Please enter a valid email address.'),
			}).then(fp_email => {
				U.loading_start()
				U.ajax('send_token_signin_email', {user_email: fp_email, token_duration: 60}, result=>{
					U.loading_stop()
					let msg
					if (result.status != 'ok') {
						if (result.status === 'bad_email') {
							msg = 'We couldn’t find an account for the email you entered.'
						} else {
							msg = 'The one-time sign-in link could not be sent.'
						}
						console.log('Error in token signin ajax call: ' + result.status)
					} else {
						msg = 'One-time sign-in link sent. If you don’t receive the link within one minute, <b>please check your spam or junk folder</b>, and remember that <b>the link will expire after one hour</b>.'
					}
					this.$alert(msg)
				})
			}).catch(n=>{console.log(n)}).finally(f=>{})
		},

		oauth_sign_in() {
			vapp.sign_in('oauth')
		},

		register_for_rosetta_exchange() {
			vapp.show_exchange_register = true
			this.cancel_sign_in()
		},

		async sign_in(values) {
			values.email = $.trim(values.email)
			values.password = $.trim(values.password)

			// READY TO SIGN IN...

			// store email in local storage
			U.local_storage_set('sparklsalt_login_email', values.email)
			U.loading_start('', 'initialize_app')
			await vapp.initialize_app({
				email: values.email,
				password: values.password,
			})

			if (this.login_error == 'ad_fail') {
				this.formAddError('email', 'Unknown email address')
				this.formAddError('password', 'Invalid password')
			} else if (this.login_error == 'sis_fail') {
				this.formAddError('email', 'Your email address could not be verified via your SIS')
			} else if (/password/i.test(this.login_error)) {
				this.formAddError('password', this.login_error)
			} else {
				this.formAddError('email', this.login_error)
			}
		},

		// Microsoft SAML sign in
		msft_sign_in() {
			// READY TO SIGN IN...

			window.location.href = '/src/msftoidclogin.php'
		},

		cancel_sign_in() {
			// if the user tried to go directly to a private framework and needed to sign in, but then cancelled,
			if (vapp.case_tree_component && !vapp.case_tree_component.initialized) {
				// we need to redirect to the framework list
				vapp.go_to_route('')
			}
			this.$emit('dialog_cancel')
		}
	}
}
</script>

<style lang="scss">
.k-login-wrapper-outer {
	display:flex;
	flex-direction: column;
	background-color:#fff;
}

.k-login-wrapper {
	border-radius:8px;
	background:rgba(255, 255, 255, 1);
	padding:10px;

	.k-login-logo-wrapper {
		display:flex;
		// flex-wrap:wrap;
		align-items: center;
		// width:100%;
		margin-bottom:20px;
		border-radius:4px;
	}

	// the following css classes are injected by store.js based on env variables:
	// .k-login__logo-img-wrapper
	// .k-login__logo-img
	// .k-login-logo-wrapper-ext
	// .k-login__logo-text-ext

	.k-login__logo-text {
		flex: 0 1 auto;
		// flex: 0 1 50%;
		margin-right:15px;
		// text-align:center;
		// font-family added by k-sans-serif-font
		// color will be added by k-app-title-color
		font-weight:bold;
		font-size:36px;
		line-height:36px;
	}
}
</style>
